import { PopulatedDatabaseWatchParty } from '@fake-stack-overflow/shared';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAllWatchParties, createWatchParty } from '../services/watchService';
import useUserContext from './useUserContext';

const useAllWatchPage = () => {
  const { user, socket } = useUserContext();
  const [watchparties, setWatchparties] = useState<PopulatedDatabaseWatchParty[]>([]);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [partyName, setPartyName] = useState('');
  const [isPublic, setIsPublic] = useState(true);
  const navigate = useNavigate();

  const fetchWatchparties = async () => {
    try {
      const res = await getAllWatchParties();
      if (!res) throw new Error('Failed to fetch watchparties');
      setWatchparties(res);
      setError('');
    } catch (err) {
      setError('Failed to fetch watchparties');
    }
  };

  const handleJoin = (id: string) => {
    socket.emit('joinWatchParty', id, user.username);
    socket.emit('addParticipantToWatchParty', id, user.username);
    navigate(`/watch/${id}`);
  };

  const handleStartParty = async (p0: { customCode: string | undefined }) => {
    if (!partyName) return;

    try {
      const newParty = await createWatchParty({
        name: partyName,
        host: user.username,
        isPublic,
        isOver: false,
        videoQueue: [],
        currentVideo: { title: '', url: '' },
        chat: {
          messages: [],
          participants: [user.username],
        },
      });
      navigate(`/watch/${newParty._id}`);
    } catch (err) {
      setError('Failed to create watch party');
    }
  };

  useEffect(() => {
    fetchWatchparties();
  }, []);

  return {
    watchparties,
    error,
    showModal,
    partyName,
    isPublic,
    fetchWatchparties,
    handleJoin,
    handleStartParty,
    setShowModal,
    setPartyName,
    setIsPublic,
  };
};

export default useAllWatchPage;
